export const FILTERS = [
    { label: 'Policy Number', filterKey: 'policyNumber', type: 'text' as const },
    { label: 'Product Name', filterKey: 'productName', type: 'text' as const },
    { label: 'Brokerage', filterKey: 'mainBrokerName', type: 'text' as const },
    { label: 'Client', filterKey: 'client_name', type: 'text' as const },
    { label: 'Creation date', filterKey: 'creationDate', type: 'date_range' as const },
    { label: 'Renewal date', filterKey: 'renewalDate', type: 'date_range' as const },
    {
      label: 'Status',
      filterKey: 'state',
      type: 'select' as const,
      selectOptions: [
        { value: 'QUOTE', label: 'QUOTE' },
        { value: 'BOUND', label: 'BOUND' },
        { value: 'CANCELLED', label: 'CANCELLED' },
        { value: 'REFERRED', label: 'REFERRED' },
        { value: 'DECLINED', label: 'DECLINED' },
        { value: 'EXPIRED', label: 'EXPIRED' },
        { value: 'COOLING OFF', label: 'COOLING OFF' },
        { value: 'RENEWAL', label: 'RENEWAL' }
      ]
    }
  ] as const;